import React, { forwardRef, } from 'react';
import Button from 'react-bootstrap/Button';
export const AcButton = forwardRef(({ variant = 'main', onClick, className, children, size = 'md', disabled, height, width, tabIndex, label, type = 'button', active, ...rest }, ref) => {
    const btnVariant = variant;
    const renderStyle = () => {
        const styles = {};
        if (width) {
            if (`${width}`.endsWith('%')) {
                styles.width = `${width}`;
            }
            else {
                styles.width = `${width}px`;
            }
        }
        if (height) {
            if (`${height}`.endsWith('%')) {
                styles.height = `${height}`;
            }
            else {
                styles.height = `${height}px`;
            }
        }
        return styles;
    };
    return (React.createElement(Button, { ref: ref, ...rest, active: active, variant: btnVariant, size: size, disabled: disabled, type: type, className: className, onClick: onClick, style: renderStyle(), tabIndex: tabIndex }, label ?? children));
});
AcButton.displayName = 'AcButton';
